import React from 'react';

import classNames from 'classnames/bind';
import styles from './LoadingBar.module.scss';

const cx = classNames.bind(styles);

function LoadingBar({ theme = 'content', classname = '', containerClassName = '', area = false, center = false, areaStyle = null, style = null, state = 'pending', messageFail = '잠시 후 다시 확인해주세요' }) {
	return (
		<div
			className={cx('area', containerClassName, { loading: !area, center })}
			style={areaStyle}
		>
			{state === 'pending' && (
				<span
					className={cx(theme, classname)}
					style={style}
				/>
			)}
			{state === 'failure' && <div className={cx('message')}>{messageFail}</div>}
		</div>
	);
}

export default LoadingBar;
